import * as React from 'react'

const Text = ({text}) => {
  return (
    <p> {text} </p>
  )
}

export default Text;